module.exports = __webpack_public_path__ + "img/example_pre_1.b4cba56b.png";